import { StyledBubbleText, StyledBubbleTextBox } from './BubbleTextBox.styled';
import ResponsiveText from '@/shared/ResponsiveText/ResponsiveText';
import { useRef } from 'react';
import { AnimatePresence } from 'framer-motion';

export default function BubbleTextBox({
  bubble,
  className,
  readMode = false,
  playing = false,
  played = false,
  defaultTextColor,
}) {
  const textParentRef = useRef(null);
  const opacityVariants = {
    readMode: { opacity: 0.8 },
    unplayed: { opacity: 0.3 },
    playing: { opacity: 1 },
    played: { opacity: 1 },
  };
  return (
    <StyledBubbleTextBox
      key={`bubble-${bubble.id}`}
      className={`bubble-${bubble.id}  ${className ?? ''}`}
      $points={bubble.points}
      ref={textParentRef}
      $color={bubble.color ?? defaultTextColor}
    >
      <div className="responsive-text">
        <ResponsiveText parentRef={textParentRef}>
          {!bubble.hidden ? (
            <AnimatePresence mode="sync">
              <StyledBubbleText
                $textStyle={bubble.textStyle}
                variants={opacityVariants}
                initial={readMode ? 'notPlaying' : 'unplayed'}
                animate={
                  readMode
                    ? 'notPlaying'
                    : playing
                    ? 'playing'
                    : played
                    ? 'played'
                    : 'unplayed'
                }
                transition={{ duration: 0.3 }}
                $emphasis={true}
                dangerouslySetInnerHTML={{ __html: bubble.phrase.text }}
              />
            </AnimatePresence>
          ) : null}
        </ResponsiveText>
      </div>
    </StyledBubbleTextBox>
  );
}
